import BasicStoreIcon from './BasicStoreIcon';

export default BasicStoreIcon;